import * as types from "./actionTypes";

export const rightToWorkCheck = (documents) => ({
  type: types.RTW_INITIATE_CHECK,
  payload: documents,
});

export const rightToWorkSuccess = (result) => ({
  type: types.RTW_CHECK_SUCCESS,
  payload: result,
});

export const rightToWorkError = (err) => ({
  type: types.RTW_CHECK_ERROR,
  payload: err,
});

export const rightToWorkVerificationSetIsLoading = (isLoading) => ({
  type: types.RTW_VERIFICATION_QUEUE_IS_LOADING,
  payload: isLoading,
});

export const rightToWorkVerificationQueueSize = () => ({
  type: types.RTW_VERIFICATION_QUEUE_SIZE,
});

export const rightToWorkVerificationQueueSizeSuccess = (result) => ({
  type: types.RTW_VERIFICATION_QUEUE_SIZE_SUCCESS,
  payload: result,
});

export const rightToWorkVerificationQueuePosition = () => ({
  type: types.RTW_VERIFICATION_QUEUE_POSITION,
});

export const rightToWorkVerificationQueueRegister = () => ({
  type: types.RTW_VERIFICATION_QUEUE_REGISTER,
});

export const rightToWorkVerificationFinished = () => ({
  type: types.RTW_VERIFICATION_FINISHED,
});

export const rightToWorkVerificationQueueDetails = (result) => ({
  type: types.RTW_VERIFICATION_QUEUE_DETAILS,
  payload: result,
});
